import { useState } from "react";
import { Outlet } from "react-router-dom";

import AdminHeader from "../components/Header/AdminHeader";
import AdminMenu from "../components/Menu/AdminMenu";

import "./AdminLayout.css";

function AdminLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="admin-layout">

      {/* Slide Drawer */}

      <AdminMenu
        open={menuOpen}
        setOpen={setMenuOpen}
      />

      {/* Main Content */}

      <div className="admin-main">

        <AdminHeader
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />

        <main className="admin-content">

          <Outlet />

        </main>

      </div>

    </div>
  );
}

export default AdminLayout;